namespace RioERP.Web.Modules.Orders.CommonController {
    export interface OrderEmailRequest extends Serenity.ServiceRequest {
        status?: string;
        ids?: string;
    }
}
